import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import App from './App';
import authReducer from './reducers/authReducer';
import alertReducer from './reducers/alertReducer';
import serviceReducer from './reducers/serviceReducer';
import loadingReducer from './reducers/loadingReducer';

//let env = process.env.NODE_ENV || 'development';

const loggerMiddleware = createLogger();
let store = createStore(
	combineReducers({
		auth: authReducer,
		alert: alertReducer,
		loading: loadingReducer,
		service: serviceReducer
	}),
	applyMiddleware(
		loggerMiddleware,
		thunkMiddleware
	)
);

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js